import { render, staticRenderFns } from "./editAreaNews.vue?vue&type=template&id=1ca97aff&scoped=true"
import script from "./editAreaNews.vue?vue&type=script&lang=js"
export * from "./editAreaNews.vue?vue&type=script&lang=js"
import style0 from "./editAreaNews.vue?vue&type=style&index=0&id=1ca97aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca97aff",
  null
  
)

export default component.exports